export const generate_code = (): string => {
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

	let array = new Uint8Array(4)
	window.crypto.getRandomValues(array)

	array = array.map((x) => chars.charCodeAt(x % chars.length))

	const random = String.fromCharCode.apply(null, array)

	return random
}
